import React, { useState } from "react";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Collapse from "@material-ui/core/Collapse";
import { useTranslation } from "react-i18next";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import eightAxios from "configs/axiosConfig";
import { WORKER_QR_PRINT_URL, WORKER_QR_URL } from "configs/constants";
import axios from "axios";
// import { saveAs } from "file-saver";

const FileDownload = require("js-file-download");
const today = new Date();

const useStyles = makeStyles((theme) => ({
  labelSpan: {
    fontWeight: "500",
  },
  valueSpan: {
    width: "100%",
    textTransform: "uppercase",
  },
  button: {
    width: "100px",
    textTransform: "capitalize",
  },
  nameSpan: {
    fontWeight: "bold",
    color: theme.palette.primary.main,
    "&:hover": {
      cursor: "pointer",
    },
  },
}));

const ImageRenderField = (props) => {
  const {
    label,
    altValue,
    value,
    enableDownload,
    enablePrint,
    buttonText,
    showText = "QR",
  } = props;
  const { t } = useTranslation();

  const [showImage, setShowImage] = useState(false);
  const classes = useStyles();
  const params = useParams();
  const API_VERSION = "v1";
  const API_URL = process.env.REACT_APP_API_URL;
  let baseURL = `${API_URL}${API_VERSION}/`;

  const downloadClickHandler = () => {
    const config = { ids: [params.id] };
    const url = baseURL + WORKER_QR_URL;
    const headers = {
      Authorization: `JWT ${localStorage.getItem("token")}`,
    };
    axios({
      url: url,
      method: "get",
      headers: headers,
      responseType: "blob",
      params: config,
    }).then(function (response) {
      console.log(response.data);
      let date =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate();
      FileDownload(response.data, "Worker_QR_Code" + date + ".pdf");
    });
  };

  const printClickHandler = () => {
    const config = { params: { ids: [params.id] } };
    eightAxios.get(WORKER_QR_PRINT_URL, config).then((response) => {
      const url = response.data.file_path;
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("target", "_blank");
      document.body.appendChild(link);
      link.click();
      link.remove();
    });
  };

  return (
    <Grid container item lg={12} direction="column">
      <Grid item lg={12}>
        <span className={classes.labelSpan}>{label}</span>
      </Grid>
      <Grid item>
        <span
          className={classes.nameSpan}
          style={{
            display: "flex",
          }}
          onClick={() => setShowImage(!showImage)}
        >
           {t("Show")} {showText} {showImage ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </span>
        <Collapse in={showImage} unmountOnExit>
          <Grid item lg={12} style={{ marginLeft: "45px" }}>
            <img src={value} alt={altValue} height={130} width={130} />
          </Grid>

          {enableDownload || enablePrint ? (
            <Grid item container spacing={2}>
              {enableDownload ? (
                <Grid item>
                  <Button
                    className={classes.button}
                    color="primary"
                    variant="contained"
                    onClick={downloadClickHandler}
                  >
                  {buttonText ? t(buttonText) : t("Download")}

                  </Button>
                </Grid>
              ) : null}
              {enablePrint ? (
                <Grid item>
                  <Button
                    className={classes.button}
                    color="primary"
                    variant="contained"
                    onClick={printClickHandler}
                  >
                    {buttonText ? t(buttonText) : t("Print")}
                  </Button>
                </Grid>
              ) : null}
            </Grid>
          ) : null}
        </Collapse>
      </Grid>
    </Grid>
  );
};

ImageRenderField.propTypes = {
  label: PropTypes.string,
  altValue: PropTypes.string,
  value: PropTypes.any,
  valueType: PropTypes.string,
  enableDownload: PropTypes.bool,
  enablePrint: PropTypes.bool,
  downloadUrl: PropTypes.string,
  buttonText: PropTypes.string,
  showText: PropTypes.string,
};

export default ImageRenderField;
